export const availableLocales = ['uz', 'ru'];
